export default __webpack_public_path__ + "static/media/before-you-start.13eed414.svg";